/**
 * Wire schema for `GET /resources/featured-products?id=…` as the Featured
 * Product Slider and the single Builder tile read it. `products` are SCAPI
 * `getProducts` items; only `id` is the contract here — the rest is handed to
 * the existing SCAPI → `HecProduct` adapters untouched, hence `.passthrough()`.
 */
import { z } from "zod";

/**
 * Most ids one request will read. A slider shows 3; the rest are backups, and
 * past a handful they stop being useful while every extra id still costs SCAPI
 * payload. The route truncates; the Builder help text says the same.
 */
export const FEATURED_PRODUCTS_MAX_IDS = 12;

export const featuredProductsResponseSchema = z
  .object({
    products: z.array(z.object({ id: z.string().min(1) }).passthrough()),
  })
  .passthrough();
